const questions = [
  {
    "question": "What first draws you toward Pagan paths?",
    "options": [
      {
        "label": "Nature, plants, seasons, and everyday connection with the land",
        "scores": {
          "green-witchcraft": 3,
          "druidry": 2,
          "celtic-paganism": 1,
          "animism": 1
        }
      },
      {
        "label": "Ritual, symbolism, magic, and a seasonal spiritual framework",
        "scores": {
          "wicca": 3,
          "eclectic-paganism": 1
        }
      },
      {
        "label": "Ancient religions, historical sources, and rebuilding older practices",
        "scores": {
          "reconstructionism": 3,
          "hellenism": 2,
          "heathenry": 1,
          "kemeticism": 2
        }
      },
      {
        "label": "Freedom to learn from several paths and create a personal practice",
        "scores": {
          "eclectic-paganism": 3,
          "green-witchcraft": 1,
          "wicca": 1
        }
      },
      {
        "label": "Contemporary spirit journeys, rhythmic sound, and reflective exploration",
        "scores": {
          "neo-shamanism": 4
        }
      },
      {
        "label": "Specifically Norse religion, sagas, deities, and Old Norse sources",
        "scores": {
          "norse-paganism": 4,
          "heathenry": 1
        }
      }
    ]
  },
  {
    "question": "How would you most like nature to appear in your practice?",
    "options": [
      {
        "label": "Through herbs, gardens, plants, and practical earth-based work",
        "scores": {
          "green-witchcraft": 3,
          "eclectic-paganism": 1,
          "animism": 1
        }
      },
      {
        "label": "Through sacred trees, landscapes, poetry, contemplation, and ecology",
        "scores": {
          "druidry": 3,
          "celtic-paganism": 2
        }
      },
      {
        "label": "Through seasonal ritual, moon symbolism, and the Wheel of the Year",
        "scores": {
          "wicca": 3,
          "druidry": 1
        }
      },
      {
        "label": "Nature matters, but deity, culture, or historical tradition matters more",
        "scores": {
          "hellenism": 2,
          "heathenry": 2,
          "reconstructionism": 1
        }
      },
      {
        "label": "Building reciprocal relationships with animals, plants, rivers, and places",
        "scores": {
          "animism": 4,
          "druidry": 1
        }
      },
      {
        "label": "Using rhythm and focused imagery in contemporary guided journeys",
        "scores": {
          "neo-shamanism": 4
        }
      },
      {
        "label": "Learning from one named Celtic-language region and its landscape",
        "scores": {
          "celtic-paganism": 4,
          "druidry": 1
        }
      }
    ]
  },
  {
    "question": "Which mythic or devotional direction interests you most right now?",
    "options": [
      {
        "label": "Norse gods, sagas, runes, and northern European myth",
        "scores": {
          "norse-paganism": 3,
          "heathenry": 2,
          "reconstructionism": 1
        }
      },
      {
        "label": "Greek gods, heroes, household worship, and ancient festivals",
        "scores": {
          "hellenism": 3,
          "reconstructionism": 2
        }
      },
      {
        "label": "Celtic stories, regional traditions, land, ancestors, and seasonal customs",
        "scores": {
          "celtic-paganism": 3,
          "druidry": 2,
          "reconstructionism": 1
        }
      },
      {
        "label": "I am not committed to one pantheon or may not center deities at all",
        "scores": {
          "eclectic-paganism": 3,
          "green-witchcraft": 2,
          "wicca": 1
        }
      },
      {
        "label": "Egyptian deities, ma’at, ancient Nile sources, and home offerings",
        "scores": {
          "kemeticism": 4,
          "reconstructionism": 1
        }
      }
    ]
  },
  {
    "question": "How important is historical accuracy to you?",
    "options": [
      {
        "label": "Very important—I want primary sources, archaeology, and careful reconstruction",
        "scores": {
          "reconstructionism": 4,
          "hellenism": 1,
          "heathenry": 1,
          "kemeticism": 2
        }
      },
      {
        "label": "Important, but I also want a living modern practice",
        "scores": {
          "heathenry": 2,
          "hellenism": 2,
          "norse-paganism": 1,
          "celtic-paganism": 1,
          "kemeticism": 1
        }
      },
      {
        "label": "Useful for context, but symbolism and personal meaning matter more",
        "scores": {
          "wicca": 2,
          "eclectic-paganism": 2,
          "druidry": 1
        }
      },
      {
        "label": "I am more interested in present-day nature practice than ancient reconstruction",
        "scores": {
          "green-witchcraft": 3,
          "druidry": 2
        }
      },
      {
        "label": "Historical context matters, and I also want to relate attentively to living places",
        "scores": {
          "animism": 3,
          "druidry": 1
        }
      },
      {
        "label": "I want to study Old Norse sources and how a Norse path is practiced today",
        "scores": {
          "norse-paganism": 4,
          "heathenry": 1
        }
      }
    ]
  },
  {
    "question": "Which ritual atmosphere sounds most appealing?",
    "options": [
      {
        "label": "A cast circle, candles, symbolic tools, invocations, and intentional ritual structure",
        "scores": {
          "wicca": 4,
          "eclectic-paganism": 1
        }
      },
      {
        "label": "Offerings, libations, prayers, and devotional relationship with deities",
        "scores": {
          "hellenism": 3,
          "heathenry": 2,
          "reconstructionism": 1,
          "kemeticism": 2
        }
      },
      {
        "label": "Outdoor ritual near trees, water, stones, or meaningful landscapes",
        "scores": {
          "druidry": 3,
          "celtic-paganism": 2,
          "green-witchcraft": 1
        }
      },
      {
        "label": "A simple personal ritual that changes depending on what I need",
        "scores": {
          "eclectic-paganism": 3,
          "green-witchcraft": 1
        }
      },
      {
        "label": "A clean home shrine with offerings and prayers for Egyptian deities",
        "scores": {
          "kemeticism": 4
        }
      },
      {
        "label": "A guided journey using rhythmic sound, followed by reflection",
        "scores": {
          "neo-shamanism": 4
        }
      },
      {
        "label": "Offerings shaped by a particular Celtic-language culture and its sources",
        "scores": {
          "celtic-paganism": 4,
          "reconstructionism": 1
        }
      }
    ]
  },
  {
    "question": "What role would you like magic or divination to play?",
    "options": [
      {
        "label": "A meaningful role—spellcraft, energy work, divination, and ritual magic interest me",
        "scores": {
          "wicca": 3,
          "eclectic-paganism": 2
        }
      },
      {
        "label": "Herbs, folk practices, charms, and practical nature-based magic interest me most",
        "scores": {
          "green-witchcraft": 3,
          "celtic-paganism": 1
        }
      },
      {
        "label": "Runes or historically rooted divination interest me, but devotion matters too",
        "scores": {
          "norse-paganism": 3,
          "heathenry": 2
        }
      },
      {
        "label": "Magic is secondary; devotional or historically grounded religion interests me more",
        "scores": {
          "hellenism": 3,
          "reconstructionism": 2
        }
      },
      {
        "label": "Contemporary journeying with rhythmic drumming or a rattle",
        "scores": {
          "neo-shamanism": 4
        }
      },
      {
        "label": "Careful relationships with the land and other-than-human beings, without requiring magic",
        "scores": {
          "animism": 4
        }
      }
    ]
  },
  {
    "question": "What kind of community would feel most natural?",
    "options": [
      {
        "label": "A small ritual group or coven-like setting with shared seasonal practice",
        "scores": {
          "wicca": 3
        }
      },
      {
        "label": "A hearth, family, kindred, or community built around reciprocity and shared customs",
        "scores": {
          "heathenry": 3,
          "norse-paganism": 2
        }
      },
      {
        "label": "A nature-focused grove or group connected by learning, ecology, and seasonal observance",
        "scores": {
          "druidry": 3,
          "celtic-paganism": 1
        }
      },
      {
        "label": "Mostly solitary, with freedom to learn from many communities when useful",
        "scores": {
          "eclectic-paganism": 3,
          "green-witchcraft": 2
        }
      },
      {
        "label": "A contemporary journeying circle or workshop with clear boundaries",
        "scores": {
          "neo-shamanism": 3
        }
      },
      {
        "label": "Local, place-based practice that may be personal or shared with others",
        "scores": {
          "animism": 3
        }
      }
    ]
  },
  {
    "question": "Which calendar or festival approach interests you most?",
    "options": [
      {
        "label": "The Wheel of the Year and modern seasonal Sabbats",
        "scores": {
          "wicca": 3,
          "druidry": 2
        }
      },
      {
        "label": "Historically informed Greek festival and household calendars",
        "scores": {
          "hellenism": 4,
          "reconstructionism": 1
        }
      },
      {
        "label": "Norse or broader Germanic seasonal observances and ancestral customs",
        "scores": {
          "heathenry": 3,
          "norse-paganism": 3
        }
      },
      {
        "label": "A flexible seasonal calendar based on my local environment and personal practice",
        "scores": {
          "green-witchcraft": 2,
          "eclectic-paganism": 3,
          "druidry": 1
        }
      },
      {
        "label": "Egyptian new-year and deity festivals, with care for changing historical calendars",
        "scores": {
          "kemeticism": 4
        }
      },
      {
        "label": "Seasonal traditions studied within a particular Celtic-language culture",
        "scores": {
          "celtic-paganism": 4
        }
      },
      {
        "label": "Norse regional festivals and ancestor customs studied in context",
        "scores": {
          "norse-paganism": 4,
          "heathenry": 1
        }
      }
    ]
  },
  {
    "question": "Which set of values or themes speaks to you most?",
    "options": [
      {
        "label": "Hospitality, reciprocity, ancestors, oaths, and community responsibility",
        "scores": {
          "heathenry": 4,
          "norse-paganism": 1
        }
      },
      {
        "label": "Wisdom, creativity, nature, poetry, sacred landscape, and reflection",
        "scores": {
          "druidry": 3,
          "celtic-paganism": 2
        }
      },
      {
        "label": "Devotion, offerings, household religion, tradition, and relationship with the gods",
        "scores": {
          "hellenism": 4,
          "reconstructionism": 1
        }
      },
      {
        "label": "Personal growth, flexibility, experimentation, and creating meaningful combinations",
        "scores": {
          "eclectic-paganism": 4,
          "wicca": 1
        }
      },
      {
        "label": "Ma’at, fairness, care for others, and right relationship",
        "scores": {
          "kemeticism": 4
        }
      },
      {
        "label": "Reciprocity and responsibility toward animals, plants, places, and ancestors",
        "scores": {
          "animism": 4
        }
      }
    ]
  },
  {
    "question": "What kind of learning sounds most enjoyable?",
    "options": [
      {
        "label": "Archaeology, academic books, translations, history, and primary sources",
        "scores": {
          "reconstructionism": 4,
          "hellenism": 1,
          "kemeticism": 2
        }
      },
      {
        "label": "Mythology, sagas, rune history, ancestors, and northern European sources",
        "scores": {
          "norse-paganism": 3,
          "heathenry": 2
        }
      },
      {
        "label": "Plants, ecology, herbs, field observation, gardening, and hands-on learning",
        "scores": {
          "green-witchcraft": 4,
          "druidry": 1
        }
      },
      {
        "label": "Ritual books, symbolism, meditation, magical methods, and structured beginner guides",
        "scores": {
          "wicca": 4,
          "eclectic-paganism": 1
        }
      },
      {
        "label": "Egyptian texts, temple history, archaeology, and modern Kemetic practice",
        "scores": {
          "kemeticism": 4,
          "reconstructionism": 1
        }
      },
      {
        "label": "The histories and limits of contemporary journeying methods",
        "scores": {
          "neo-shamanism": 4
        }
      },
      {
        "label": "Regional Celtic languages, folklore, and historically grounded sources",
        "scores": {
          "celtic-paganism": 4,
          "reconstructionism": 1
        }
      }
    ]
  },
  {
    "question": "Which altar or sacred-space items sound most meaningful?",
    "options": [
      {
        "label": "Candles, pentacle symbolism, chalice, incense, and ritual tools",
        "scores": {
          "wicca": 4
        }
      },
      {
        "label": "Herbs, flowers, stones, branches, seeds, and responsibly gathered natural items",
        "scores": {
          "green-witchcraft": 3,
          "druidry": 2
        }
      },
      {
        "label": "Deity images, incense, offering bowls, libations, and devotional objects",
        "scores": {
          "hellenism": 3,
          "reconstructionism": 1,
          "kemeticism": 1
        }
      },
      {
        "label": "Runes, ancestor items, a hammer symbol, drinking horn, or historically inspired objects",
        "scores": {
          "norse-paganism": 3,
          "heathenry": 3
        }
      },
      {
        "label": "An Egyptian deity image, clean shrine, and water or food offerings",
        "scores": {
          "kemeticism": 4
        }
      },
      {
        "label": "A drum or rattle and a notebook for contemporary journeys",
        "scores": {
          "neo-shamanism": 4
        }
      },
      {
        "label": "No set altar; attentive care for familiar places and beings",
        "scores": {
          "animism": 4
        }
      }
    ]
  },
  {
    "question": "Which statement sounds closest to what you want right now?",
    "options": [
      {
        "label": "I want to study one historical tradition deeply and rebuild practice carefully",
        "scores": {
          "reconstructionism": 4,
          "hellenism": 1,
          "heathenry": 1
        }
      },
      {
        "label": "I want a strong land-centered spirituality with room for myth, creativity, and seasonal practice",
        "scores": {
          "druidry": 3,
          "celtic-paganism": 3
        }
      },
      {
        "label": "I want a flexible personal path that can evolve as I learn",
        "scores": {
          "eclectic-paganism": 4,
          "green-witchcraft": 1
        }
      },
      {
        "label": "I want structured ritual, seasonal observance, and a meaningful magical practice",
        "scores": {
          "wicca": 4
        }
      },
      {
        "label": "I want historically informed devotion to Egyptian deities",
        "scores": {
          "kemeticism": 4,
          "reconstructionism": 1
        }
      },
      {
        "label": "I want contemporary guided journeys, studied with clear ethical boundaries",
        "scores": {
          "neo-shamanism": 4
        }
      },
      {
        "label": "I want reciprocal relationships with the living landscape around me",
        "scores": {
          "animism": 4
        }
      },
      {
        "label": "I want to focus on Norse deities and Old Norse sources",
        "scores": {
          "norse-paganism": 4,
          "heathenry": 1
        }
      }
    ]
  }
];
const pathInfo = {
  "wicca": {
    "name": "Wicca",
    "short": "A modern Pagan religion with structured ritual, seasonal observance, and magical practice in many forms.",
    "next": [
      "Study the history of modern Wicca",
      "Learn the Wheel of the Year",
      "Compare initiatory and eclectic forms"
    ],
    "url": "/pages/wicca"
  },
  "green-witchcraft": {
    "name": "Green Witchcraft",
    "short": "A flexible nature-centered approach focused on plants, land, seasons, and practical relationship with the living world.",
    "next": [
      "Learn ethical herb sourcing",
      "Keep a local seasonal journal",
      "Study plant safety before practical use"
    ],
    "url": "/pages/green-witchcraft"
  },
  "druidry": {
    "name": "Druidry",
    "short": "A modern spiritual family emphasizing nature, sacred landscape, creativity, seasonal observance, and learning.",
    "next": [
      "Compare modern Druid organizations",
      "Begin a sit-spot practice",
      "Read about historical druids separately from modern Druidry"
    ],
    "url": "/pages/druidry"
  },
  "heathenry": {
    "name": "Heathenry",
    "short": "A family of modern Germanic Pagan religions focused on reciprocity, ancestors, deities, household and community practice.",
    "next": [
      "Learn the concept of gifting and reciprocity",
      "Study regional historical sources",
      "Explore household and ancestor practice"
    ],
    "url": "/pages/heathenry"
  },
  "hellenism": {
    "name": "Hellenism",
    "short": "A modern revival and reconstruction of ancient Greek religious practice, including devotion, offerings, and festival traditions.",
    "next": [
      "Study household religion",
      "Read translated hymns and primary sources",
      "Learn how ancient festival calendars varied by place"
    ],
    "url": "/pages/hellenism"
  },
  "celtic-paganism": {
    "name": "Celtic Paganism",
    "short": "A broad umbrella for modern practices inspired by different Celtic-language cultures, myths, landscapes, and traditions.",
    "next": [
      "Choose a specific culture or region to study",
      "Use scholarly translations and folklore sources",
      "Avoid treating all Celtic traditions as one system"
    ],
    "url": "/pages/celtic-paganism"
  },
  "norse-paganism": {
    "name": "Norse Paganism",
    "short": "A modern path inspired by pre-Christian Norse religion, mythology, deities, ancestors, and historical sources.",
    "next": [
      "Read translated Eddic material with commentary",
      "Study runes historically before using modern systems",
      "Compare Norse Paganism with broader Heathenry"
    ],
    "url": "/pages/norse-paganism"
  },
  "eclectic-paganism": {
    "name": "Eclectic Paganism",
    "short": "A flexible personal approach that draws from multiple sources while requiring careful context and ethical study.",
    "next": [
      "Keep a source journal",
      "Study each borrowed practice in context",
      "Build a clear personal ethical framework"
    ],
    "url": "/pages/eclectic-paganism"
  },
  "reconstructionism": {
    "name": "Reconstructionism",
    "short": "A research-centered approach that uses historical, archaeological, linguistic, and primary-source evidence to rebuild older religions.",
    "next": [
      "Choose one historical culture to focus on",
      "Build a scholarly reading list",
      "Separate evidence from modern creative additions"
    ],
    "url": "/pages/reconstructionism"
  },
  "kemeticism": {
    "name": "Kemeticism",
    "short": "Modern Egyptian-inspired religious paths with home devotion, offerings, ma’at, and careful study of ancient sources.",
    "next": [
      "Read about ancient Egyptian religious diversity",
      "Explore home offerings and ma’at",
      "Compare modern Kemetic approaches"
    ],
    "url": "/pages/kemeticism"
  },
  "neo-shamanism": {
    "name": "Neo-Shamanism",
    "short": "A range of contemporary practices such as guided journeying; distinct from living Indigenous religions with their own traditions and authorities.",
    "next": [
      "Compare contemporary journeying approaches",
      "Learn the history of the term shaman",
      "Respect the boundaries of living Indigenous traditions"
    ],
    "url": "/pages/neo-shamanism-animism"
  },
  "animism": {
    "name": "Animism",
    "short": "Ways of relating to other-than-human beings and places across diverse traditions; animism is not a single religion or a required form of journeying.",
    "next": [
      "Study relationships with local land and living beings",
      "Learn how animist traditions differ",
      "Read the guide alongside Neo-Shamanism to compare them"
    ],
    "url": "/pages/neo-shamanism-animism"
  }
};

function initPathQuiz(root) {
  let index = 0;
  let answers = Array(questions.length).fill(null);
  const progress = root.querySelector('[data-progress]');
  const label = root.querySelector('[data-progress-label]');
  const title = root.querySelector('[data-question]');
  const options = root.querySelector('[data-options]');
  const back = root.querySelector('[data-back]');
  const next = root.querySelector('[data-next]');
  const result = root.querySelector('[data-result]');
  const questionPanel = root.querySelector('[data-question-panel]');

  function scores() {
    const totals = Object.fromEntries(Object.keys(pathInfo).map(key => [key, 0]));
    answers.forEach((answer, questionIndex) => {
      if (answer === null) return;
      Object.entries(questions[questionIndex].options[answer].scores).forEach(([key, value]) => {
        totals[key] += value;
      });
    });
    return Object.entries(totals)
      .map(([key, score]) => ({ key, score }))
      .sort((a, b) => b.score - a.score);
  }

  function render() {
    const question = questions[index];
    progress.style.width = ((index + 1) / questions.length * 100) + '%';
    label.textContent = 'Question ' + (index + 1) + ' of ' + questions.length;
    title.textContent = question.question;
    options.innerHTML = '';
    question.options.forEach((answer, answerIndex) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'quiz-option' + (answers[index] === answerIndex ? ' selected' : '');
      button.innerHTML = '<span>' + String.fromCharCode(65 + answerIndex) + '</span><strong></strong>';
      button.querySelector('strong').textContent = answer.label;
      button.onclick = () => { answers[index] = answerIndex; render(); };
      options.appendChild(button);
    });
    back.disabled = index === 0;
    next.disabled = answers[index] === null;
    next.textContent = index === questions.length - 1 ? 'See my starting points' : 'Next';
  }

  function finish() {
    const ranked = scores();
    const top = ranked.slice(0, 3);
    const primary = pathInfo[top[0].key];
    localStorage.setItem('pathsEarthQuizResult', JSON.stringify({
      primary_path: top[0].key,
      secondary_paths: top.slice(1).map(item => item.key),
      scores: Object.fromEntries(ranked.map(item => [item.key, item.score])),
      answers,
      saved_at: new Date().toISOString(),
    }));
    questionPanel.hidden = true;
    result.hidden = false;
    const cards = top.map((item, cardIndex) => {
      const path = pathInfo[item.key];
      return '<article class="quiz-result-card ' + (cardIndex === 0 ? 'primary' : '') + '">' +
        '<span>0' + (cardIndex + 1) + '</span><h3>' + path.name + '</h3><p>' + path.short + '</p>' +
        '<a href="' + path.url + '">Read the ' + path.name + ' guide →</a></article>';
    }).join('');
    result.innerHTML = '<div class="eyebrow">Your strongest starting point</div><h2>' + primary.name +
      '</h2><p>' + primary.short + '</p>' +
      '<div class="quiz-disclaimer">This is a starting point, not a label. Your interests can overlap several traditions and may change as you learn.</div>' +
      '<div class="quiz-result-grid">' + cards + '</div><h3>Suggested next steps</h3><ul>' +
      primary.next.map(step => '<li>' + step + '</li>').join('') + '</ul>' +
      '<div class="quiz-result-actions"><button class="button" type="button" data-restart>Retake quiz</button>' +
      '<a class="button ghost dark" href="' + primary.url + '">Explore your starting point</a>' +
      '<a class="button ghost dark" href="/pages/learn">Browse all guides</a></div>';
    result.querySelector('[data-restart]').onclick = () => {
      index = 0;
      answers = Array(questions.length).fill(null);
      result.hidden = true;
      questionPanel.hidden = false;
      render();
      root.scrollIntoView({ behavior: 'smooth' });
    };
  }

  back.onclick = () => { index = Math.max(0, index - 1); render(); };
  next.onclick = () => {
    if (answers[index] === null) return;
    if (index < questions.length - 1) { index++; render(); } else { finish(); }
  };
  render();
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-path-quiz]').forEach(initPathQuiz);
});
